<template>
    <div class="layout" @click="departmentBar.selecting = false">
        <Layout style="height:100%">
            <Header style=" height:44px;line-height:44px;padding:0 20px">
                <Row style="width:100%;">
                    <Col style span="8">
                        <Button
                            v-if="portrait"
                            ghost
                            size="small"
                            type="text"
                            style="font-size:30px;display:flex;align-items:center;line-height:0;padding:0;vertical-align:middle"
                            icon="md-menu"
                            @click="side_hide = !side_hide"
                        ><span style="font-size:17px;color:white;display:block">&nbsp;{{userName}}</span></Button>
                        <Logo v-if="!portrait&&!isCordova()" :position="'main'"></Logo>
                        <span v-if="!portrait&&!isCordova()&&isGZTV&&hasPlatformPermission('LIVE01')" class="header_link_select">{{ $t('Home.Header.liveCms') }}</span>
                        <span v-if="!portrait&&!isCordova()&&isGZTV&&hasPlatformPermission('MT01')" class="header_link" @click="toMaterialCms">{{ $t('Home.Header.materialCms') }}</span>
                    </Col>
                   
                    <Col style="text-align:right;float: right" span="16">
                        <!-- <div v-if="!portrait&&!isCordova() && departmentId && departmentId != 0" class="department-bar" style="display: inline-block">
                            <span>{{ $t('Home.Header.department') }}</span>
                            <span class="department-text" @click.stop="departmentBar.selecting = !departmentBar.selecting">
                                <span :title="departmentName">{{departmentName}}</span>
                                <icon class="icon" :type="departmentBar.selecting ? 'md-arrow-dropup' : 'md-arrow-dropdown'"></icon>
                            </span>
                            <div class="department-select" v-show="departmentBar.selecting" @click.stop="departmentBar.selecting = true">
                                <Tree ref="departmentBarTree" :data="departmentBar.treeData" show-checkbox check-directly check-strictly
                                      @on-check-change="onDepartmentTreeCheck"></Tree>
                            </div>
                        </div> -->
                        <div style="display: inline-block">
                            <!-- 报名系统 -->
                            <Button
                                    v-if="isGZTV&&!portrait&&!isCordova()&&hasPermission('outRegistrationSystem')"
                                    type="text"
                                    size="large"
                                    icon="md-school"
                                    ghost
                                    style="padding-left: 0"
                                    @click="openPage('/user_cms/kuaihd/gotoEnroll.action', '_blank')"
                            >{{$t('Home.Header.outRegistrationSystem')}}</Button>
                            <!-- 用户中心|用户名 -->
                            <Button
                                    v-if="!portrait&&!isCordova()&&hasPlatformPermission('USER01')"
                                    type="text"
                                    size="large"
                                    icon="md-person"
                                    ghost
                                    style="padding-left: 0"
                                    @click="toUserCenter"
                           >{{userName}}</Button>
                            <span v-else class="user-nick" style="padding-left: 0"><Icon type="md-person"></Icon> {{userName}}</span>
                            <!-- 管理员中心 -->
                            <Button
                                    v-if="!portrait&&!isCordova()&&adminCenter&&hasPlatformPermission('ADMIN01')"
                                    type="text"
                                    size="large"
                                    icon="md-key"
                                    ghost
                                    style="padding-left: 0"
                                    @click="toAdminCenter"
                            >{{ isDAYOO ? $t('Home.Header.adminCenterDayoo') : $t('Home.Header.adminCenter') }}</Button>
                            <Button
                                    v-show="!portrait&&!isCordova()&&liveAppUrl"
                                    @click.stop="openLiveAppUrl"
                                    type="text"
                                    size="large"
                                    class="app"
                                    ghost
                            >
                                <Poptip placement="bottom" trigger="hover" :title="$t('Home.Header.liveApp.poptipTitle')">
                                    <Logo :position="'app'"></Logo>
                                    <span>&nbsp;{{ $t('Home.Header.liveApp.title') }}</span>
                                    <div slot="content">
                                        <canvas id="app_qr" />
                                    </div>
                                </Poptip>
                            </Button>
                            <Button v-if="!portrait&& exit !== false" type="text" size="large" icon="ios-power" ghost @click="logout">{{ $t('Home.Header.logout') }}</Button>
                        </div>
                    </Col>
                </Row>
            </Header>
            <Layout :style="{height:'100%'}">
                <Sider
                    collapsible
                    :collapsed-width="0"
                    hide-trigger
                    width="180"
                    v-model="side_hide"
                    class="menuSider"
                    :style="{background: '#fff',height:'100%',overflow:'auto'}"
                >
                    <div class="main-title">{{ $t('Home.Sider.mainTitle') }}</div>
                    <Menu
                        ref="menu"
                        theme="light"
                        style="overflow:auto;margin-bottom: 20px"
                        height="auto"
                        width="auto"
                        @on-select="side_hide=portrait||false"
                        :active-name="activePath"
                        :open-names="['1','2','3']"
                    >
                        <Submenu v-if="hasPermission('liveRoom')" name="1">
                            <template slot="title">
                                <Icon type="md-desktop"/>{{ $t('Home.Sider.liveRoomManagement.title') }}
                            </template>
                            <MenuItem v-if="hasPermission('liveRoomList')" name="liveRoom_list" to="/home/liveRoom_list/all" @click.native="refresh('/home/liveRoom_list/all')">
                                直播间
                            </MenuItem>
                            <MenuItem v-if="hasPermission('slowLive')" name="liveRoom_slowlive" to="/home/liveRoom_list/slowlive" @click.native="refresh('/home/liveRoom_list/slowlive')">
                                慢直播间
                            </MenuItem>
                            <MenuItem v-if="hasPermission('liveRoomCategory') && !isDgrb" name="live_category" to="/home/live_category/all" @click.native="refresh('/home/live_category/all')">
                                {{ $t('Home.Sider.liveRoomManagement.liveRoomCategory') }}
                            </MenuItem>
                            <MenuItem v-if="hasPermission('correlativeReport')" name="related_report" to="/home/related_report/all" @click.native="refresh('/home/related_report/all')">
                                {{ $t('Home.Sider.liveRoomManagement.relatedReport') }}
                            </MenuItem>
                            <MenuItem v-if="hasPermission('liveTask')" name="live_record" to="/home/live_record/all" @click.native="refresh('/home/live_record/all')">
                                {{ $t('Home.Sider.liveRoomManagement.liveRecord') }}
                            </MenuItem>
                        </Submenu>
                        <MenuItem v-if="hasPermission('materialInfo') && !isGZTV" name="material_management" to="/home/material_management/all" @click.native="refresh('/home/material_management/all')">
                            <Icon type="md-bookmarks"/>{{ $t('Home.Sider.materialManagement.title') }}
                        </MenuItem>
                        <MenuItem v-if="hasPermission('watermark')" name="watermark_management" to="/home/watermark_management/all" @click.native="refresh('/home/watermark_management/all')">
                            <Icon type="md-water"/>{{ $t('Home.Sider.watermarkManagement.title') }}
                        </MenuItem>

                        <Submenu v-if="hasPermission('director')" name="2">
                            <template slot="title">
                                <Icon type="logo-youtube"/>{{ $t('Home.Sider.directorManagement.title') }}
                            </template>
                            <MenuItem v-if="hasPermission('directorList')" name="director" to="/home/director/all" @click.native="refresh('/home/director/all')">
                                {{ $t('Home.Sider.directorManagement.director') }}
                            </MenuItem>
                            <MenuItem v-if="hasPermission('directorList') && hasPermission('directorExtension') && hasPermission('slowliveDirector')" name="slowdirector" to="/home/director/all/slow" @click.native="refresh('/home/director/all/slow')">
                                慢直播导播
                            </MenuItem>
                            <MenuItem v-if="hasPermission('directorList') && hasPermission('directorExtension') && hasPermission('vrDirector')" name="vrdirector" to="/home/director/all/vr" @click.native="refresh('/home/director/all/vr')">
                                VR导播
                            </MenuItem>
                            <MenuItem
                                v-if="hasPermission('selectGlobalEffectGroupTemplate') && depId && depId != 0"
                                name="department_template"
                                to="/home/department_template/all"
                                @click.native="refresh('/home/department_template/all')"
                            >
                                {{ $t('Home.Sider.directorManagement.departmentTemplate') }}
                            </MenuItem>
                            <MenuItem v-if="hasPermission('groupMaterialTemplate')" name="material_template" to="/home/material_template/all" @click.native="refresh('/home/material_template/all')">
                                {{ $t('Home.Sider.directorManagement.materialTemplate') }}
                            </MenuItem>
                        </Submenu>
                        <MenuItem v-if="hasPermission('cloudEditor') && !isGZTV" name="cloud_editor" to="/home/cloud_editor/all" @click.native="refresh('/home/cloud_editor/all')">
                            <Icon type="ios-cut"/>{{ $t('Home.Sider.cloudEditor.title') }}
                        </MenuItem>
                        <MenuItem v-if="hasPermission('realEditor') && !isGZTV" name="real_editor" to="/home/real_editor/all" @click.native="refresh('home/real_editor/all')">
                            <Icon type="md-cut"/>{{ $t('Home.Sider.realEditor.title') }}
                        </MenuItem>
                        <Submenu v-if="hasPermission('virtualOffice') && !isGZTV && false" name="3"><!-- 已屏蔽演播厅管理-->
                            <template slot="title">
                                <Icon type="md-podium"/>{{ $t('Home.Sider.virtualOfficeManagement.title') }}
                            </template>
                            <MenuItem v-if="hasPermission('virtualOfficeList')" name="virtual_office" to="/home/virtual_office/all" @click.native="refresh('/home/virtual_office/all')">
                                {{ $t('Home.Sider.virtualOfficeManagement.virtualOffice') }}
                            </MenuItem>
                            <MenuItem v-if="hasPermission('virtualOfficeTemplate')" name="virtual_office_template" to="/home/virtual_office_template/all" @click.native="refresh('/home/virtual_office_template/all')">
                                {{ $t('Home.Sider.virtualOfficeManagement.virtualOfficeTemplate') }}
                            </MenuItem>
                        </Submenu>
                        <MenuItem v-if="hasPermission('hardEncoder') && !isGZTV" name="hard_encoder" to="/home/hard_encoder/all" @click.native="refresh('/home/hard_encoder/all')">
                            <Icon type="md-construct"/>{{ $t('Home.Sider.hardEncoder.title') }}
                        </MenuItem>
                    </Menu>
                </Sider>
                <div v-if="!side_hide" @click="side_hide=true" class="menuSiderMask"></div>
                <Layout class="main-layout" :class="{'full-layout':full_layout}">
                    <div class="content-title main-layout-title">
                        <div
                            @click="canBack && $router.back()"
                            v-if="canBack && $route.meta.title != '关联列表'"
                            class="content-title-back"
                        >
                            <Icon type="ios-arrow-back"/>
                            <span>&nbsp;</span>
                        </div>
                        <div
                            @click="canBack && $router.push('../all')"
                            v-if="canBack && $route.meta.title == '关联列表'"
                            class="content-title-back"
                        >
                            <Icon type="ios-arrow-back"/>
                            <span>&nbsp;</span>
                        </div>
                        <Icon :type="$route.meta.icon"/>
                        <span>{{ routerTitle }}</span>
                    </div>
                    <!-- IOS上必须使用-webkit-overflow-scrolling:touch，否则滚动会很卡顿 -->
                    <Content class="main-layout-content" >
                        <router-view :key="activeDate"></router-view>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template> 

<script>
import { mapState } from "vuex";
import logger from '@/assets/log'
import helper from '@/assets/helper'
import api from '@/api/Api'
import Logo from '@/components/Logo'
import qr from "qrcode";
const log = logger("views:home");

export default {
    name: "home",
    components: { Logo },
    computed: {
        routerTitle() {
            if (typeof this.$route.meta.title === 'string') {
                return this.$t(this.$route.meta.title);
            }
            if (typeof this.$route.meta.title === 'function') {
                const title = this.$route.meta.title(this.$route);
                return this.$t(title);
            }
            return '';
        },
        full_layout(){
            if (this.currentPath.indexOf("/home/material/editor") >= 0)
                return true;
            if (this.currentPath.indexOf("/home/material/mergeEditor") >= 0)
                return true;

            return false;
        },
        showUploader: {
            set() {
                this.$store.commit("uploader/showUploader", false);
            },
            get() {
                return this._showUploader;
            }
        },
        ...mapState({
            userName: state => state.user.name,
            departmentName: state => state.department.currentName,
            departmentId: state => state.department.currentId,
            _showUploader: state => state.uploader.showUploader,
            uploaderReady: state =>
                state.uploader.UploadServer.loadingStatus == "done",
            UploadServer: state => state.uploader.UploadServer,
            uploaderResult: state => state.uploader.newMaterialStatus,
            uploadingList: state =>
                state.uploader.uploading.filter(i => i.status == "uploading"),
            isGZTV: state => state.config.profile == 'gztv',
            isDAYOO: state => state.config.profile == 'dayoo',
            isDgrb: state => state.config.profile === 'dgrb',
            liveAppUrl: state => state.config.liveAppUrl != 'about:blank' && state.config.liveAppUrl,
            depId: state => state.department.currentId,
            adminCenter: state => state.config.adminCenter,
            exit: state =>state.config.exit,
        }),
        activePath() {
            // 当前显示的高亮menu
            if (this.currentPath.indexOf("/home/material_management/") >= 0)
                return "material_management";
            if (this.currentPath.indexOf("/home/watermark_management/") >= 0)
                return "watermark_management";
            if (this.currentPath.indexOf("/home/liveRoom_list/slowlive") >= 0)
                return "liveRoom_slowlive";
            if (this.currentPath.includes("/home/live_category")) {
                return "live_category";
            }
            if (this.currentPath.indexOf("/home/liveRoom_list/") >= 0) {
                if(this.currentPath.indexOf("slowlive") >= 0) {
                    return "liveRoom_slowlive";
                } else {
                    return "liveRoom_list";
                }
            }
            if (this.currentPath.indexOf("/home/live_category/") >= 0)
                return "live_category";
            if (this.currentPath.indexOf("/home/related_report/") >= 0)
                return "related_report";
            if (this.currentPath.indexOf("/home/live_record/") >= 0)
                return "live_record";
            if (this.currentPath.indexOf("/home/director/") >= 0) {
                if (this.currentPath.indexOf("/home/director/all/slow") >= 0)
                    return "slowdirector";
                else if (this.currentPath.indexOf("/home/director/all/vr") >= 0)
                    return "vrdirector";
                else
                    return "director";
            }
                
            if (this.currentPath.indexOf("/home/department_template/") >= 0)
                return "department_template";
            if (this.currentPath.indexOf("/home/material_template/") >= 0)
                return "material_template";
            if (this.currentPath.indexOf("/home/cloud_editor/") >= 0)
                return "cloud_editor";
            if (this.currentPath.indexOf("/home/real_editor/") >= 0)
                return "real_editor";
            if (this.currentPath.indexOf("/home/virtual_office/") >= 0)
                return "virtual_office";
            if (this.currentPath.indexOf("/home/virtual_office_template/") >= 0)
                return "virtual_office_template";
            if (this.currentPath.indexOf("/home/hard_encoder/") >= 0)
                return "hard_encoder";
            return this.currentPath.split('/')[2];
        },
        canBack() {
            //是否显示返回按钮，点击返回按钮调用 router.back
            let noBack = [
                "/home/material_management/all",
                "/home/watermark_management/all",
                "/home/liveRoom_list/all",
                "/home/liveRoom_list/slowlive",
                "/home/live_category/all",
                "/home/related_report/all",
                "/home/live_record/all",
                "/home/director/all",
                "/home/slowdirector/all",
                "/home/vrdirector/all",
                "/home/department_template/all",
                "/home/material_template/all",
                "/home/cloud_editor/all",
                "/home/real_editor/all",
                "/home/virtual_office/all",
                "/home/virtual_office_template/all",
                "/home/hard_encoder/all",
            ];

            let currentPath = this.currentPath;
            return (
                noBack.filter(o => {
                    return currentPath.indexOf(o) >= 0;
                }).length == 0
            );
        }
    },
    watch: {
        uploaderResult(val) {
            if (!val.length) return;

            let item = val[val.length - 1];
            if (!item.status) {
                this.$Notice.success({
                    title: this.$t('Home.message.upload.success') + `(${item.name})`
                });
            } else {
                this.$Notice.error({
                    title: this.$t('Home.message.upload.error') + `(${item.name})`,
                    desc: item.error
                });
            }
        },
        // "departmentBar.selecting"(yes) {
        //     yes && this.getDepartmentList();
        // }
    },
    data() {
        return {
            fromPath:"",
            title: "首页",
            portrait: this.isPortrait(),
            side_hide: this.isPortrait(),
            //menu根据它来更新当前的高亮item
            currentPath: this.$route.fullPath,
            loadingUploadServerUrl: true,
            permissionContainer: [],
            departmentBar: {
                selecting: false,
                treeData: []
            },
            activeDate: 1
        };
    },
    beforeRouteUpdate(to, from, next) {
        log("route from:%o to:%o",from.path,to.path)
        this.fromPath = from.path;
        this.currentPath = to.path;
        if(this.portrait){
            this.side_hide = true;
        }
        next();
    },
    methods: {
        refresh(path) {
            if(path == this.fromPath){
                this.activeDate = new Date().getTime();
            }
            this.fromPath = this.$route.path
        },
        logout() {
            this.$store.dispatch("user/logout");
        },
        openPage(url, target) {
            window.open(url, target || '_blank');
        },
        toUserCenter(){
            this.$store.dispatch("user/toUserCenter");
        },
        toMaterialCms(){
            this.$store.dispatch("user/toMaterialCms");
        },
        toAdminCenter(){
            this.$store.dispatch("user/toAdminCenter");
        },
        onDepartmentTreeCheck(checked, curr) {
            // 只允许选择一个节点
            checked.forEach(n => n.checked = false);
            curr.checked = true;

            this.departmentBar.selecting = false;
            this.$store.commit("department/current", {
                id: curr.id,
                name: curr.title
            });
        },
        // async getDepartmentList() {
        //     try {
        //         let ret = await api.call("department/getDepList", {}, true);
        //         let tree = helper.getTree(ret.data, 'pId', ret.data[0].pId);
        //         helper.travel(tree, "children", n => {
        //             n.title = n.name;
        //             n.checked = (n.id == this.$store.state.department.currentId);
        //             n.expand = helper.hasCheckedNode(n, this.depId)
        //         });
        //         if(tree[0]) {
        //             tree[0].expand = true;
        //         }
        //         this.departmentBar.treeData = tree;
        //     } catch (e) {
        //         this.$Notice.error({
        //             title: e.message
        //         });
        //     }
        // },
        showLiveQrcode(url) {
            url && qr.toCanvas(document.getElementById("app_qr"), url);
        },
        openLiveAppUrl(){
            open(this.liveAppUrl,'_blank')
        }
    },
    mounted() {
        this.isPortrait((e)=>{ 
            this.$data.portrait = e.matches;
            this.$data.side_hide = e.matches;
            
        })
        this.$store.dispatch("uploader/getUploadServer");
        // this.getDepartmentList()
        this.showLiveQrcode(this.liveAppUrl);
    },
    beforeDestroy() {}
};
</script>

<style lang="less">
@import "../assets/main-variable.less";
html {
    width: 100%;
    height: 100%;
}
body {
    width: 100%;
    height: 100%;
}
.header_link{
    display: inline-block;
    height: 100%;
    font-size: 14px;
    padding: 0 10px;
    color: white;
    cursor: pointer;
}
.header_link:hover{
    color: #515a6e;
    transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear;
}
.header_link_select{
    display: inline-block;
    height: 100%;
    font-size: 14px;
    padding: 0 10px;
    background-color: #F5F7F9;
    color: black;
    cursor: pointer;
}
.app {
    display: inline-block;
    text-align: center;
    padding: 0;
    position: relative;
    margin: auto;
    color: white;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        color: #5f97d8;
        text-decoration: underline;
    }
    * {
        vertical-align: middle;
    }
    img {
        width: 20px;
        height: 20px;
    }
}
.pager {
    line-height:45px;
}
// .filter{
    // overflow:auto;
    // white-space: nowrap
// }
.titleLink {
    color: black;
    cursor: pointer;
}
.titleLink:hover {
    text-decoration: underline;
}

#main {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
}

.sub-nav-title {
    display: block;
    font-size: 14px;
    padding: 17px 24px;
    * {
        vertical-align: middle;
    }
}
.content-title {
    font-size: 18px;
    padding: 0px 0 0 10px;
    & > * {
        vertical-align: middle;
    }
    .content-title-back {
        margin-right: 5px;
        display: inline-block;
        cursor: pointer;
        & > * {
            vertical-align: middle;
        }
        &:hover {
            border-radius: 5px;
            background: @primary-color;
            color: white;
        }
    }
}
.main-title {
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    background: #f2f2f2;
    padding-left: 25px;
}
// .material_preview {
//     & > div {
        // z-index:9999
//     }
// }
.menuSiderMask{
    display:none;
}

.menuSider{
    overflow:auto;
}
@media all and (orientation : portrait){ 

    .filter{
        padding:5px
    }
    .menuSider{
        position: absolute;
        z-index:1000;
        // overflow:hidden;
        box-shadow: rgba(0,0,0,0.3) 0 0 10px
    }
    .menuSider .ivu-layout-sider-children{
        position: absolute!important;
        right:0;
        width:150px!important;
    }
    .menuSiderMask{
        background:rgba(255,255,255,0.9);height:100%;width:100%;
        position: absolute;z-index:999;
        display:block;
    }
    /* .menuSider  */

}

.ivu-form {
    margin-right: 3em;
}
.ivu-input-word-count{
    text-align: center;
    position: absolute;
    right: 0;
    bottom: 2px;
    transform: translateX(100%);
    padding-left: 7px;
    z-index: 1;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-end;
    color: #808695;
    font-size: 12px;
}
</style>
<style scoped lang="less">
.main-layout{
    padding:10px;height:100%;
}
// .main-layout-title{

// }
.main-layout-content{
    padding:10px;height:100%;background:transparent;overflow:auto;-webkit-overflow-scrolling: touch;
}
.full-layout.main-layout{
    padding:0!important;
}
.full-layout .main-layout-title{
    display:none!important;
}
.full-layout .main-layout-content{
    padding:0!important
} 
.spin {
    z-index: 1000;
}
.layout {
    background: #f5f7f9;
    position: relative;
    overflow: hidden;
    height: 100%;
}
.layout-logo {
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
}
.layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 0px;
}
.user-nick {
    font-size: 14px;
    color: #fff;
    padding: 6px 15px;
    display: inline-block;
    vertical-align: middle;
    line-height: 21px;
}
</style>
